import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import App from './App.tsx';
import { ProtectedRoute } from './components/ProtectedRoute';
import './index.css';

const SignInPage = lazy(() =>
  import('./pages/SignInPage').then((module) => ({ default: module.SignInPage }))
);
const SignUpPage = lazy(() =>
  import('./pages/SignUpPage').then((module) => ({ default: module.SignUpPage }))
);
const ForgotPasswordPage = lazy(() =>
  import('./pages/ForgotPasswordPage').then((module) => ({ default: module.ForgotPasswordPage }))
);
const ResetPasswordPage = lazy(() =>
  import('./pages/ResetPasswordPage').then((module) => ({ default: module.ResetPasswordPage }))
);
const DashboardPage = lazy(() =>
  import('./pages/DashboardPage').then((module) => ({ default: module.DashboardPage }))
);
const PublicReceiptPage = lazy(() =>
  import('./pages/PublicReceiptPage').then((module) => ({ default: module.PublicReceiptPage }))
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Suspense
          fallback={
            <main className="flex min-h-screen items-center justify-center bg-[#F6F5F2] text-sm text-[#6B7280]">
              Loading Duly Cited…
            </main>
          }
        >
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/r/:cardId" element={<PublicReceiptPage />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<App />} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
